// Safari (private mode, ITP, or cross-site OAuth callback contexts) can make
// `window.localStorage` throw or return null when accessed. Callers should
// treat a null return as "no persisted value" rather than crashing.
const getStore = (): Storage | null => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
};

export const safeLocalStorage = {
  getItem(key: string): string | null {
    try {
      return getStore()?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      getStore()?.setItem(key, value);
    } catch {
      /* storage unavailable — silently drop */
    }
  },
  removeItem(key: string): void {
    try {
      getStore()?.removeItem(key);
    } catch {
      /* storage unavailable — silently drop */
    }
  },
  clear(): void {
    try {
      getStore()?.clear();
    } catch {
      /* storage unavailable — silently drop */
    }
  },
};
